import { Component } from '@angular/core';

@Component({
  selector: 'app-prestations',
  imports: [],
  templateUrl: './prestations.component.html',
  styleUrl: './prestations.component.scss'
})
export class PrestationsComponent {

}
